const checkIfDuplicateExists = function (arr) {
  return new Set(arr).size !== arr.length;
};

const validateUniquenessOfLocationCode = function (e) {
  let locationCodes = [];
  $('#locations_table > tr').each(function (index, tr) {
    let row = $(tr);
    let locationCode = row.find('.location_code').val();
    locationCodes.push(locationCode);
  });
  if (checkIfDuplicateExists(locationCodes)) {
    e.preventDefault(); // Stop the form from submitting
    e.stopPropagation();
    $('#locationsErrorMessage').removeClass('d-none');
  }
};

document.addEventListener('turbolinks:load', function () {
  $('.new_area').on('submit', function (e) {
    validateUniquenessOfLocationCode(e);
  });
  $('.edit_area').on('submit', function (e) {
    validateUniquenessOfLocationCode(e);
  });
});
